var LaravelElixirBundle = (function (exports) {
'use strict';

$(document).ready(function(){
    //Animate arrow bouncing on email submit hover
    $('.red-submit').hover(function(){
        $('.arrow-icon').addClass('arrow-animate');
    },function(){
        $('.arrow-icon').removeClass('arrow-animate');
    });

    $('.red-submit').hover(function(){
        $('.nav-arrow-icon').addClass('arrow-animate');
    },function(){
        $('.nav-arrow-icon').removeClass('arrow-animate');
    });

    //Fire Tag Manager event for full review clickthrough with brand
    $('.read-full-link').click(function(){
        var brand = $(this).next().val();
        TagManager.fireEvent('readfull' , {"cardbrand":brand});
    });

    //Fire Tag Manager event for deal banner clickthrough with brand
    $('.dealbanner').click(function(){
        var brand = $(this).prev().val();
        TagManager.fireEvent('dealbannerclick' , {"cardbrand":brand});
    });

});


// Parse the URL
function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

//Get URL parmeters and store in session
window.onload = function(){
    // Give the URL parameters variable names
    var source = getParameterByName('utm_source');
    var campaign = getParameterByName('utm_campaign');
    var content = getParameterByName('utm_content');
    var gcid = getParameterByName('gcid');
    var kid = getParameterByName('kid');
    var s1 = getParameterByName('s1');
    var s2 = getParameterByName('s2');
    var s3 = getParameterByName('s3');

    //Construct Session Data object to send with request
    var sessionData = new FormData();

    //Append CSRF token in default layout
    var token = document.getElementById('token').value;
    sessionData.append('_token',token);

    //Check if paramaters have been passed and append values to Session Data
    if(source != null) {
        sessionData.append('utm_source',source);
    }
    if(campaign != null) {
        sessionData.append('utm_campaign',campaign);
    }
    if(content != null) {
        sessionData.append('utm_content',content);
    }
    if(gcid != null) {
        sessionData.append('gcid',gcid);
    }
    if(kid != null) {
        sessionData.append('kid',kid);
    }
    if(s1 != null) {
        sessionData.append('s1',s1);
    }
    if(s2 != null) {
        sessionData.append('s2',s2);
    }
    if(s3 != null) {
        sessionData.append('s3',s3);
    }

    axios.post('/update-session',sessionData);
};

// Load iframes when in view
$(document).ready(function(){
    $('.ba-holder').one('inview', function(event, isInView) {
      if (isInView) {
          var iframe = loadframe($(this));
      } else {
        // element has gone out of viewport
      }
    });

});

var loadframe = function (el) {
    return $('<iframe>', {
        src: el.data("framesrc"),
        width: el.data("framewidth"),
        height: el.data("frameheight")
        }).appendTo(el);
};

return exports;

}({}));
//# sourceMappingURL=appB.js.map
